module.exports = __webpack_public_path__ + "new-zealand.svg?9e5477855410bef88d7076f6c9f440e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/new-zealand.svg
// module id = 246
// module chunks = 10